export enum TimerType {
  Clock = 1,
  Timer = 2
}
